var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQueryStraight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 145,
    viewBox: "0 0 137 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.85 49.21V32.49H120.85V24.5H112.86V16.59H104.87V16.4H104.68V8.41H85.21V0.410004H53.33V8.41H32.9299V16.4V16.59H24.9399V24.5H16.95V32.49H8.94995V49.21H0.959961V80.65H8.94995V96.33H16.95V112.32H24.9399V120.31H32.9299V128.3H48.9199V136.3H88.8799V128.3H104.87V120.31H112.86V112.32H120.85V96.33H128.85V80.65H136.84V49.21H128.85Z",
    fill: "#FDAE35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.22 136.31H53.3301V144.3H85.22V136.31Z",
    fill: "#D38B2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.85 80.65V96.31H120.85V104.3H112.86V112.3H104.87V120.29H96.8798V128.28H96.9298L96.8798 128.3H85.3198V136.3H104.87V128.28H112.86V120.29H120.85V112.3H128.85V96.64H136.84V80.65H128.85Z",
    fill: "#D38B2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4299 136.3V128.3H40.9199L40.89 128.28H40.9199V120.29H32.9299H32.7599V112.3H24.9399V104.3H16.95V96.31H8.94995V80.65H0.959961V96.64H8.94995V112.3H16.95V120.29H24.7599H24.9399V128.28H32.9299V136.3H53.4299Z",
    fill: "#D38B2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.87 24.23H96.8799V32.22H104.87V24.23Z",
    fill: "#FFEBD4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8799 20.4H92.8799V24.4H96.8799V20.4Z",
    fill: "#FFDAA9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.87 32.22H104.87V36.22H108.87V32.22Z",
    fill: "#FFDAA9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.86 78.87H80.8899V86.86H112.86V78.87Z",
    fill: "#A32732"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9099 78.87H24.9399V86.86H56.9099V78.87Z",
    fill: "#A32732"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9399 57.66H56.9099V78.87H64.9V57.66H72.9V78.01H80.89V57.66H88.8799H96.8799H112.86V78.01H120.85V49.66H16.95V78.01H24.9399V57.66Z",
    fill: "#A32732"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9099 57.66H24.9399V78.87H56.9099V57.66Z",
    fill: "#ECF0F1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.86 57.66H80.8899V78.87H112.86V57.66Z",
    fill: "#ECF0F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.29 60.62H93.04V71.55H99.29V60.62Z",
    fill: "#A32732"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5801 60.62H38.3301V71.55H44.5801V60.62Z",
    fill: "#A32732"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryStraight);
export default __webpack_public_path__ + "static/media/query_straight.30756d90d3dc2196e80c1b9c3cbf2a4f.svg";
export { ForwardRef as ReactComponent };